import Index from './index.vue'
import List from './components/List.vue'
// import Create from './components/Create.vue'
// import Profile from './view/Profile.vue'
// import Edit from './components/Edit.vue'


export default [
  {
    path: 'mads',
    name: 'mads',
    component: Index,
    title: 'mads',
    redirect: { name: 'mads-list' },
    children: [
      {
        path: 'list',
        name: 'mads-list',
        component: List,
      },
      // {
      //   path: 'create',
      //   name: "adImage-create",
      //   component: Create
      // },
      // {
      //   path: 'edit/:id',
      //   name: "adImage-edit",
      //   component: Edit
      // },
      // {
      //   path: 'profile/:id',
      //   name: "adImage-profile",
      //   component: Profile
      // }
    ],

  },
]
